import {
	Button,
	HStack,
	Tooltip,
} from '@montel/montelpro-shared-components-v2';
import { useState } from 'react';
import { ExportPayload, exportExcel } from './exportExcel';
import { Row } from '@tanstack/react-table';
import { getProductUserExportPayload } from './getProductUserExportPayload';
import { ExcelExportType } from 'components/tables/Table.interfaces';
import { MontelAccount } from 'domain/account/interfaces';

interface ExcelExportProps<T> {
	documentName: string;
	title: string;
	rows: Row<T>[];
	type: ExcelExportType;
}

function ExcelExport<T>({
	documentName,
	title,
	type,
	rows,
}: ExcelExportProps<T>) {
	const [isExporting, setIsExporting] = useState(false);

	let payload: ExportPayload;

	switch (type) {
		case ExcelExportType.ProductUser:
			payload = getProductUserExportPayload(
				rows.map((r) => r.original as MontelAccount),
			);
			break;
		default:
			throw new Error('Invalid type.');
	}

	const onExportClick = () => {
		setIsExporting(true);

		exportExcel(payload.data, payload.columnWidths, documentName);
		setIsExporting(false);
	};

	return (
		<HStack align="center">
			<Button
				text={title}
				onClick={onExportClick}
				type="submit"
				loadingText="Exporting..."
				isLoading={isExporting}
				isDisabled={isExporting}
			/>
			<Tooltip contentSize="lg">
				Export table contents to Excel. Note: Sorting and filters apply
				- if you have applied a filter, only the filtered data will be
				exported. The same applies to sorting: excel data will be sorted
				by the same column as the table.
			</Tooltip>
		</HStack>
	);
}

export default ExcelExport;
